import React, { Component } from 'react';
import { QRCode } from 'react-qr-svg';
import {
    Progress, Button, DatePicker, message,
} from 'antd';
import moment from 'moment';
import { base } from '../../base';
import MachineTermsView from './MachineTermsView';
import MachineAddContainer from '../containers/MachineAddContainer';
import constants from '../../constants';

const date = new Date().getDate();

class MachineDetailsHeaderView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openMachineForm: false,
        };
        this.handleClose = this.handleClose.bind(this);
        let timeUpdate = moment().add(this.props.machine.dayscheck, 'days').calendar();
        base.update(`machines/${this.props.extraUser.companyid}/${this.props.machineId}`, {
            data: {
                nextupdate: timeUpdate,
                // service: values.service.format('YYYY-MM-DD'),
            },
            then(err) {
                if (!err) {
                    // Nothing
                }
            },
        });
    }


    showDateService() {
        message.warning('Su servicio es hoy');
    }

    updateDateService() {
        message.error('Actualice Fecha de Servicio');
    }

    handleClose() {
        this.setState({
            openMachineForm: false,
        });
    }

    render() {
        const editButton = (
            <Button onClick={() => this.setState({ openMachineForm: true })}>
                Edit
            </Button>
        );
        return (
            <div>
                <MachineAddContainer
                    machineId={this.props.machineId}
                    openForm={this.state.openMachineForm}
                    onCancel={this.handleClose}
                    closeForm={this.handleClose}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                />
                <h2>
                    {this.props.machine.name}
                    <Progress percent={this.props.machine.status} />
                    {this.calculate}
                    {
                        moment(this.props.machine.service).date() === date && (
                            this.showDateService()
                        )
                    }
                    {/* {
                        moment(this.props.machine.service).date() < date && (
                            this.updateDateService()
                        )

                    } */}
                </h2>
                <div className="row">
                    <div className="col-md-2">
                        <QRCode
                            bgColor="#FFFFFF"
                            fgColor="#000000"
                            level="Q"
                            style={{ width: '100%' }}
                            value={`${this.props.machine.companyid}@@@${this.props.machineId}`}
                        />
                    </div>
                    <div className="col-md-5">
                        {this.props.extraUser.type === constants.ADMIN_ROLE && editButton}
                        {this.props.extraUser.type === constants.SADMIN_ROLE && editButton}
                        <div>
                            {/* Ultimo registro: dd/mm/aaaa */}
                            <br />
                            <MachineTermsView
                                location={this.props.machine.location}
                                brand={this.props.machine.brand}
                                model={this.props.machine.model}
                                serial={this.props.machine.serial}
                                year={this.props.machine.year}
                                service={this.props.machine.service}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MachineDetailsHeaderView;



// WEBPACK FOOTER //
// ./src/components/views/MachineDetailsHeaderView.js